module.exports = require("commonmark");


//////////////////
// WEBPACK FOOTER
// external "commonmark"
// module id = 622
// module chunks = 0